var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05 4.55005C4.79559 4.55005 5.4 5.15446 5.4 5.90005L5.4 22.1C5.4 22.8456 4.79558 23.45 4.05 23.45C3.30442 23.45 2.7 22.8456 2.7 22.1L2.7 5.90005C2.7 5.15446 3.30442 4.55005 4.05 4.55005ZM14.4546 8.99545C14.9818 9.52266 14.9818 10.3774 14.4546 10.9046L12.7092 12.65L22.95 12.65C23.6956 12.65 24.3 13.2545 24.3 14C24.3 14.7456 23.6956 15.35 22.95 15.35L12.7092 15.35L14.4546 17.0955C14.9818 17.6227 14.9818 18.4774 14.4546 19.0046C13.9274 19.5319 13.0726 19.5319 12.5454 19.0046L8.49541 14.9546C8.24223 14.7015 8.1 14.3581 8.1 14C8.1 13.642 8.24223 13.2986 8.49541 13.0455L12.5454 8.99545C13.0726 8.46825 13.9274 8.46825 14.4546 8.99545Z",
    fill: "#00B061"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.68d1f570da9ffc4cfde297b84691c783.svg";
export { ForwardRef as ReactComponent };